import { themeColor } from "./_helpers";

export const utilityTokens = {
  fg: themeColor({
    base: "{colors.neutral.500}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.500}",
  }),
  hoverBg: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  hoverFg: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.white}",
    _themeWhite: "{colors.neutral.700}",
  }),
  menuSeparator: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.neutral.50}",
    _themeWhite: "{colors.neutral.200}",
  }),
};
